import { Box, Link as MUILink, Typography } from "@mui/material";
import * as styles from "./linkCardStyles";

interface LinkCardProps {
    title: string;
    url: string;
    imageUrl: string;
}

const LinkCard: React.FC<LinkCardProps> = ({ title, url, imageUrl }) => {
    const handleClick = () => {
        if (typeof window !== "undefined" && (window as any)._paq) {
            (window as any)._paq.push(["trackLink", url, "link"]);
        }
    };

    return (
        <MUILink
            href={url}
            underline="none"
            onClick={handleClick}
            sx={styles.linkCardStyles}
        >
            <Box sx={styles.linkCardImageWrapper}>
                <Box
                    component="img"
                    sx={styles.linkCardImage}
                    alt={title}
                    src={imageUrl}
                />
            </Box>

            <Typography variant="h6" sx={styles.linkCardTitle}>
                {title}
            </Typography>
        </MUILink>
    );
};

export default LinkCard;
